import React from 'react';
import PropTypes from 'prop-types';
import TaskModule from 'modules/task';
import { Components, Utils, translate } from 'versafleet-core';
import { connect } from 'react-redux';
import ReduxActions from 'reduxActions';
import addOnsSettings from 'modules/addOns/addOnsConstants';
import JobHelper from 'utils/jobHelper';
import withRouterHooks from 'utils/routerHelper';

class TaskDetailEdit extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      form: structuredClone({ ...this._getDefaultForm(), ...props.form }),
      error: {},
      isChanged: false,
    };
    this.onFormChange = this._onFormChange.bind(this);
  }

  UNSAFE_componentWillMount() {
    this.props.dispatch(ReduxActions.customFieldGroup.fetchOptionCustomFieldGroupList());
    this.props.dispatch(ReduxActions.constant.fetchList());
    if (!Utils.Helper.isNullOrUndefined(this.props.account.default_custom_field_group_id)) {
      this.props.dispatch(ReduxActions.customFieldGroup
        .fetch(this.props.account.default_custom_field_group_id));
    }
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (nextProps.customFieldGroups !== this.props.customFieldGroups
      && !Utils.Helper.isNullOrUndefined(nextProps.account.addons_setting)
      && nextProps.account.addons_setting.custom_field) {
      const customFieldGroupId = this.state.form.custom_field_group_id;

      this._onFormChange('custom_fields_attributes',
        this._getCustomFieldsDefaultForm(nextProps.form.custom_fields_attributes,
          nextProps.customFieldGroups[customFieldGroupId]));
    }
  }

  componentDidUpdate(prevProps, previousState) {
    // Auto apply skills from billing account on billing account change
    if (
      prevProps.billingAccounts !== this.props.billingAccounts
        && this.state.form.billing_account_id
        && this.props.billingAccounts[this.state.form.billing_account_id]
    ) {
      const billingAccount = this.props.billingAccounts[this.state.form.billing_account_id];

      if (this.props.account.addons_setting.skills === addOnsSettings.subscribed) {
        this.setState((prevState) => {
          const skills = {
            driver_skill_list: (prevState.form.driver_skill_list || []).concat(
              (billingAccount.driver_skills || [])
                .map(skill => skill.name)
                .filter(skill => !(prevState.form.driver_skill_list || []).includes(skill)),
            ),
            vehicle_skill_list: (prevState.form.vehicle_skill_list || []).concat(
              (billingAccount.vehicle_skills || [])
                .map(skill => skill.name)
                .filter(skill => !(prevState.form.vehicle_skill_list || []).includes(skill)),
            ),
          };

          if (this.props.account.addons_setting.parts_and_config === addOnsSettings.subscribed) {
            skills.vehicle_part_skill_list = (prevState.form.vehicle_part_skill_list || []).concat(
              (billingAccount.vehicle_part_skills || [])
                .map(skill => skill.name)
                .filter(skill => !(prevState.form.vehicle_part_skill_list || []).includes(skill)),
            );
          }

          return {
            form: {
              ...prevState.form,
              ...skills,
            },
          };
        });
      }
    }

    // Remove auto applied skills from previous billing account on change
    if (
      previousState.form.billing_account_id !== this.state.form.billing_account_id
        && previousState.form.billing_account_id
        && this.props.billingAccounts[previousState.form.billing_account_id]
    ) {
      const billingAccount = this.props.billingAccounts[previousState.form.billing_account_id];

      if (this.props.account.addons_setting.skills === addOnsSettings.subscribed) {
        const skillsToRemove = {
          driverSkills: (billingAccount.driver_skills || []).map(skill => skill.name),
          vehicleSkills: (billingAccount.vehicle_skills || []).map(skill => skill.name),
          partSkills: (billingAccount.vehicle_part_skills || []).map(skill => skill.name),
        };

        this.setState((prevState) => {
          const skills = {
            driver_skill_list: (prevState.form.driver_skill_list || [])
              .filter(skill => !skillsToRemove.driverSkills.includes(skill)),
            vehicle_skill_list: (prevState.form.vehicle_skill_list || [])
              .filter(skill => !skillsToRemove.vehicleSkills.includes(skill)),
          };

          if (this.props.account.addons_setting.parts_and_config === addOnsSettings.subscribed) {
            skills.vehicle_part_skill_list = (prevState.form.vehicle_part_skill_list || [])
              .filter(skill => !skillsToRemove.partSkills.includes(skill));
          }

          return {
            form: {
              ...prevState.form,
              ...skills,
            },
          };
        });
      }
    }
  }

  _getDefaultForm() {
    let form = {
      address_attributes: {
        name: null,
        line_1: null,
        country: null,
        zip: null,
        contact_person: null,
        contact_number: null,
        email: null,
      },
      time_type: this.props.time.time_type,
      time_from: this.props.time.time_from,
      time_to: this.props.time.time_to,
      time_window_id: this.props.time.time_window_id,
      driver_skill_list: [],
      vehicle_skill_list: [],
      vehicle_part_skill_list: [],
      epod_attachments_attributes: [],
    };

    if (this.props.account.addons_setting.custom_field === addOnsSettings.subscribed) {
      form = {
        ...form,
        custom_field_group_id: this.props.account.default_custom_field_group_id, // for validation
        custom_fields_attributes:
          this._getCustomFieldsDefaultForm(
            this.props.form.custom_fields_attributes,
            this.props.customFieldGroups[this.props.form.custom_field_group_id],
          ),
      };
    }

    return form;
  }

  _getCustomFieldsDefaultForm = (customFields, customFieldGroup) => {
    if (Utils.Helper.isNullOrUndefined(customFieldGroup)) {
      return [];
    }

    return customFieldGroup.custom_field_descriptions.map((item) => {
      const customField = Utils.Helper.isNullOrUndefined(customFields) ? {}
        : customFields.find((field) => {
          const id = Utils.Helper.isNullOrUndefined(field.custom_field_description)
            ? field.custom_field_description_id : field.custom_field_description.id;

          return id === item.id;
        });
      const value = (customField || {}).value;
      const subvalue = (customField || {}).subvalue;
      return {
        custom_field_description_id: item.id,
        value,
        subvalue,
        id: (customField || {}).id,
      };
    });
  }

  _onFormChange(fieldName, value, index, isDelete) {
    if (!this.state.isChanged) {
      this.setState({ isChanged: true });
    }

    if (fieldName === 'custom_field_group_id') {
      this.setState(prevState => ({
        form: Utils.Helper.setFilter(prevState.form, null, {
          custom_field_group_id: value,
          custom_fields_attributes: [],
        }),
      }));

      if (!Utils.Helper.isNullOrUndefined(value)) {
        this.props.dispatch(ReduxActions.customFieldGroup.fetch(value));
      }
    } else if (fieldName === 'billing_account_id') {
      if (value && value !== '') {
        this.props.dispatch(ReduxActions.billingAccount.fetch(value));
      }
      this.setState(prevState => ({
        form: {
          ...prevState.form,
          billing_account_id: value,
        },
      }));
    } else {
      this.setState(prevState => ({
        form: Utils.Helper.setFilter(prevState.form, fieldName, value, index, isDelete),
      }));
    }
  }

  _renderRightPanel() {
    return (
      <Components.Form.RightPanel>
        <Components.Form.MainButton
          id="vf-job__new-form__task-form__right-panel__save-button"
          onClick={() => {
            Utils.FullScreenLoading.FullScreenLoadingManager.open(
              this.props.strings.Job.form.task.validating,
            );
            this.props.dispatch(ReduxActions.task.validate(this.state.form))
              .then(() => {
                if (this.props.index === null) {
                  // Its a new task
                  this.props.onFormChange('tasks_attributes', this.state.form);
                  this.props.setPage(JobHelper.PageConstants.JOB_DETAIL_EDIT);
                } else {
                  // Edit an existing task
                  this.props.onFormChange('tasks_attributes', this.state.form, this.props.index);
                  this.props.setPage(JobHelper.PageConstants.JOB_DETAIL_EDIT);
                }
              })
              .catch((error) => {
                this.setState({ error });
              })
              .then(() => {
                Utils.FullScreenLoading.FullScreenLoadingManager.close();
              });
          }}
        >
          {this.props.strings.Task.form.buttons.save}
        </Components.Form.MainButton>
      </Components.Form.RightPanel>
    );
  }

  render() {
    return (
      <Components.Form.CoreLayout
        isChanged={this.state.isChanged}
        onClose={() => (this.props.location.pathname.includes('submissions')
          ? this.props.navigate('/submissions')
          : this.props.navigate('/in_progress'))}
        rightPanel={this._renderRightPanel()}
        title={(
          <Components.Form.Title>
            <Components.Form.Title.Item
              id="vf-job__new-form__task-form__menu__job-redirect"
              onClick={() => this.props.setPage(JobHelper.PageConstants.JOB_DETAIL_EDIT)}
            >
              {this.props.jobType === 'pickup'
                ? this.props.strings.Job.form.menu.jobDeliveryInfo
                : this.props.strings.Job.form.menu.jobPickupInfo}
            </Components.Form.Title.Item>
            <Components.Form.Title.Item isHighlighted>
              {this.props.jobType === 'pickup'
                ? this.props.strings.Job.form.menu.pickupTaskInfo
                : this.props.strings.Job.form.menu.deliveryTaskInfo}
            </Components.Form.Title.Item>
          </Components.Form.Title>
        )}
      >
        <TaskModule.Edit
          constant={this.props.constant}
          customFieldGroups={this.props.customFieldGroups}
          customer={this.props.customer}
          data={{
            ...this.props.form,
            job_type: this.props.jobType,
          }}
          error={this.state.error}
          form={this.state.form}
          id="vf-job__new-form__task-form__left-panel"
          isNewTask
          onFormChange={this.onFormChange}
          optionAddresses={this.props.optionAddresses}
          optionCustomFieldGroups={this.props.optionCustomFieldGroups}
        />
      </Components.Form.CoreLayout>
    );
  }
}

TaskDetailEdit.propTypes = {
  account: PropTypes.shape({
    addons_setting: PropTypes.shape({
      custom_field: PropTypes.number,
      parts_and_config: PropTypes.number,
      skills: PropTypes.number,
    }),
    default_custom_field_group_id: PropTypes.oneOfType([PropTypes.number, PropTypes.any]),
  }).isRequired,
  billingAccounts: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.number,
    driver_skills: PropTypes.arrayOf(PropTypes.shape({
      name: PropTypes.string,
    })),
    vehicle_skills: PropTypes.arrayOf(PropTypes.shape({
      name: PropTypes.string,
    })),
    vehicle_part_skills: PropTypes.arrayOf(PropTypes.shape({
      name: PropTypes.string,
    })),
  })),
  constant: PropTypes.shape({
    skills: PropTypes.shape({
      driver_skills: PropTypes.arrayOf(PropTypes.string),
      vehicle_skills: PropTypes.arrayOf(PropTypes.string),
      vehicle_part_skills: PropTypes.arrayOf(PropTypes.string),
    }),
  }).isRequired,
  customFieldGroups: PropTypes.shape(),
  customer: PropTypes.shape().isRequired,
  dispatch: PropTypes.func.isRequired,
  form: PropTypes.shape({
    custom_fields_attributes: PropTypes.arrayOf(PropTypes.shape()),
    custom_field_group_id: PropTypes.number,
  }).isRequired,
  index: PropTypes.number,
  jobType: PropTypes.oneOf(['delivery', 'pickup', 'p2p']).isRequired,
  location: PropTypes.shape({
    pathname: PropTypes.string,
  }).isRequired,
  navigate: PropTypes.func.isRequired,
  onFormChange: PropTypes.func.isRequired,
  optionAddresses: PropTypes.arrayOf(PropTypes.shape({
    value: PropTypes.string,
    text: PropTypes.string,
  })).isRequired,
  optionCustomFieldGroups: PropTypes.arrayOf(PropTypes.shape()),
  setPage: PropTypes.func.isRequired,
  strings: PropTypes.shape({
    Job: PropTypes.shape({
      form: PropTypes.shape({
        menu: PropTypes.shape({
          jobDeliveryInfo: PropTypes.string,
          jobPickupInfo: PropTypes.string,
          pickupTaskInfo: PropTypes.string,
          deliveryTaskInfo: PropTypes.string,
        }),
        task: PropTypes.shape({
          validating: PropTypes.string,
        }),
      }),
    }),
    Task: PropTypes.shape({
      form: PropTypes.shape({
        buttons: PropTypes.shape({
          save: PropTypes.string,
        }),
      }),
    }),
  }).isRequired,
  time: PropTypes.shape({
    time_from: PropTypes.string,
    time_to: PropTypes.string,
    time_type: PropTypes.string,
    time_window_id: PropTypes.number,
  }).isRequired,
};

TaskDetailEdit.defaultProps = {
  billingAccounts: [],
  customFieldGroups: {},
  index: null,
  optionCustomFieldGroups: [],
};

const mapStateToProps = (state) => {
  const {
    account, billingAccount, customFieldGroup, profile, constant,
  } = state;

  return {
    account: account.account,
    billingAccounts: billingAccount.billingAccounts,
    constant: constant.constant,
    customer: profile.profile,
    customFieldGroups: customFieldGroup.customFieldGroups,
    optionCustomFieldGroups: customFieldGroup.optionCustomFieldGroups,
  };
};

export default withRouterHooks(connect(mapStateToProps)(translate('')(TaskDetailEdit)));
